import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ApexLogo from './ApexLogo';
import { navigationLinks } from '../data/mock';

const Layout = ({ children }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (href) => {
    return location.pathname === href;
  };

  return (
    <div className="min-h-screen bg-navy-dark text-white">
      {/* Sticky Header */}
      <header
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-navy-dark bg-opacity-98 backdrop-blur-md border-b border-navy-border py-3'
            : 'bg-transparent py-4'
        }`}
      >
        <div className="max-w-7xl mx-auto px-8 flex items-center justify-between">
          <div 
            onClick={() => navigate('/')} 
            className="cursor-pointer apex-logo-wrapper"
            style={{ 
              display: 'flex',
              alignItems: 'center',
              marginRight: '4rem',
              padding: '0.5rem 0'
            }}
          >
            <ApexLogo />
          </div>

          <nav className="hidden md:flex items-center gap-8">
            {navigationLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => navigate(link.href)}
                className={`nav-link text-sm font-medium tracking-wide transition-colors duration-300 ${
                  isActive(link.href)
                    ? 'text-white'
                    : 'text-gray-400 hover:text-white'
                }`}
                style={{
                  lineHeight: '36px',
                  display: 'inline-flex',
                  alignItems: 'center'
                }}
              >
                {link.name}
              </button>
            ))}
          </nav>
        </div>
      </header>

      {/* Page Content */}
      <main>{children}</main>

      {/* Footer */}
      <footer className="py-20 px-8 border-t border-navy-border bg-navy-darker relative overflow-hidden">
        {/* Background Gradient */}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl" />
        
        <div className="max-w-7xl mx-auto relative z-10">
          {/* Strong Closing Statement */}
          <div className="text-center mb-16">
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight">
              Partner with Apex Build Project Management.
            </h3>
            <p className="text-lg text-gray-400 font-light">
              Strategic leadership for your next major project.
            </p>
          </div>

          {/* Footer Content */}
          <div className="grid md:grid-cols-3 gap-12 mb-12 text-center md:text-left">
            <div>
              <ApexLogo className="mb-4 mx-auto md:mx-0" />
              <p className="text-sm text-gray-400 mt-4 font-light">
                Independent project leadership delivering major infrastructure and commercial projects across Australia.
              </p>
            </div>
            
            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
                Navigation
              </h4>
              <div className="space-y-2">
                {navigationLinks.map((link) => (
                  <button
                    key={link.id}
                    onClick={() => navigate(link.href)}
                    className="block text-sm text-gray-400 hover:text-white transition-colors font-light"
                  >
                    {link.name}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
                Connect
              </h4>
              <div className="space-y-2 text-sm text-gray-400 font-light">
                <p>Sydney, Australia</p>
                <p className="hover:text-white transition-colors cursor-pointer">
                  contact@apxprojects.com
                </p>
                <p>+61 (0) 123 456 789</p>
                <div className="pt-4">
                  <button
                    onClick={() => window.open('https://linkedin.com', '_blank')}
                    className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 mx-auto md:mx-0"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                    LinkedIn
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-navy-border text-center text-sm text-gray-500 font-light">
            <p>© {new Date().getFullYear()} Apex Build Project Management. All rights reserved.</p>
            <p className="mt-2 text-xs text-gray-600">Lead smarter. Build better.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
